import { User } from '@/types';

export const RemainingCreditsBadge = ({ user }: { user: Pick<User, 'role' | 'credits' | 'saleCredits'> }) => {
  if(!['app','agent', 'superagent'].includes(user.role?.code || '')) {
    return <span className="text-gray-500">N/A</span>;
  }
  const userIsAgent = ['agent', 'superagent'].includes(user.role?.code || '');
  const credits = userIsAgent ? user.saleCredits || 0 : user.credits || 0;
  let bgColor = 'bg-green-500';
  const yellowThreshold = userIsAgent ? 12 : 1;

  if (credits < yellowThreshold) {
    bgColor = 'bg-red-600';
  } else if (credits === yellowThreshold) {
    bgColor = 'bg-yellow-500';
  }

  return (
    <span className={`w-12 inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-bold text-white justify-center ${bgColor}`}>
      {credits}
    </span>
  );
}
